import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import Button from '../../Button';

import Dismiss from './Dismiss';
import {
  actionClassName,
  backButtonClassName,
  headerClassName,
  headingClassName,
  preActionClassName,
  rowClassName,
} from './styles';

interface Props {
  onBack?: () => void;
  onDismiss: () => void;
  title: string;
}

const Header = ({ onBack, onDismiss, title }: Props) => {
  return (
    <div className={headerClassName}>
      <div className={rowClassName}>
        {onBack && (
          <div className={preActionClassName}>
            <Button
              className={backButtonClassName}
              faIcon={faArrowLeft}
              onClick={onBack}
            />
          </div>
        )}
        <h2 className={headingClassName}>{title}</h2>
        <div className={actionClassName}>
          <Dismiss onDismiss={onDismiss} />
        </div>
      </div>
    </div>
  );
};

Header.displayName = 'Header';

export default Header;
